import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyCVbTV0TG7JsULy1PYh-aG3Qh6tGipkWmE",
    authDomain: "mavapp-e8ded.firebaseapp.com",
    projectId: "mavapp-e8ded",
    storageBucket: "mavapp-e8ded.firebasestorage.app",
    messagingSenderId: "1026721151796",
    appId: "1:1026721151796:web:4574fbec5f6b0964224361"
  };

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };
